import { CodOrder } from "../../../types/codSalesRep";
import { CustomerOutstandingSummary, EnrichedCodPayment } from "../../../utils/codUtils";

export interface CodCustomerOption {
  key: string;
  customerId: string;
  customerCode: string;
  customerName: string;
}

const mergeCustomer = (
  map: Map<string, CodCustomerOption>,
  row: {
    customerId?: string;
    customerCode?: string;
    customerName?: string;
  }
) => {
  const customerId = row.customerId?.trim() ?? "";
  const customerCode = row.customerCode?.trim() ?? "";
  const key = customerId || customerCode;
  if (!key) return;

  const existing = map.get(key);
  map.set(key, {
    key,
    customerId: customerId || existing?.customerId || "",
    customerCode: customerCode || existing?.customerCode || "",
    customerName:
      row.customerName?.trim() ||
      existing?.customerName ||
      customerCode ||
      customerId,
  });
};

export const buildCodCustomerOptions = (
  orders: CodOrder[],
  payments: EnrichedCodPayment[],
  outstanding: CustomerOutstandingSummary[]
): CodCustomerOption[] => {
  const map = new Map<string, CodCustomerOption>();
  orders.forEach((order) => mergeCustomer(map, order));
  payments.forEach((payment) => mergeCustomer(map, payment));
  outstanding.forEach((row) => mergeCustomer(map, row));

  return Array.from(map.values()).sort((a, b) =>
    (a.customerCode || a.customerName).localeCompare(
      b.customerCode || b.customerName,
      undefined,
      { sensitivity: "base" }
    )
  );
};

export const matchesCodCustomer = (
  row: { customerId?: string; customerCode?: string },
  selected: CodCustomerOption | null
) => {
  if (!selected) return true;
  if (selected.customerId && row.customerId) {
    return row.customerId === selected.customerId;
  }
  if (selected.customerCode && row.customerCode) {
    return row.customerCode === selected.customerCode;
  }
  return false;
};

export const findCustomerOption = (
  options: CodCustomerOption[],
  key: string
): CodCustomerOption | null =>
  options.find((option) => option.key === key) ?? null;
